import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";

export default function BookingSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("loading"); // loading | paid | pending | expired | error
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let cancelled = false;
    const poll = async (n) => {
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (cancelled) return;
        if (r.data.payment_status === "paid") setStatus("paid");
        else if (r.data.status === "expired") setStatus("expired");
        else if (n >= 6) setStatus("pending");
        else {
          setTries(n + 1);
          setTimeout(() => poll(n + 1), 2000);
        }
      } catch {
        if (!cancelled) setStatus("error");
      }
    };
    poll(0);
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div className="min-h-screen grid place-items-center bg-[color:var(--bg-primary)] px-6" data-testid="booking-success-page">
      <div className="max-w-xl text-center">
        <Link to="/" className="font-heading text-3xl block mb-10">Dentainhoa<span className="text-[color:var(--accent)]">.</span></Link>
        {status === "loading" && (
          <>
            <div className="text-xs uppercase tracking-[0.28em] text-[color:var(--text-secondary)] mb-4">Procesando</div>
            <h1 className="font-heading text-5xl md:text-6xl italic tracking-tighter mb-6">Un momento…</h1>
            <p className="text-[color:var(--text-secondary)]">Verificando tu pago con Stripe {tries > 0 ? `(intento ${tries + 1}/7)` : ""}</p>
          </>
        )}
        {status === "paid" && (
          <>
            <div className="text-xs uppercase tracking-[0.28em] text-[color:var(--accent)] mb-4">Pago confirmado · 10 €</div>
            <h1 className="font-heading text-5xl md:text-6xl italic tracking-tighter mb-6">Gracias.</h1>
            <p className="text-[color:var(--text-secondary)] mb-8">Tu cita queda reservada. Recibirás confirmación por email y te contactaremos en las próximas horas para ajustar el detalle de la visita.</p>
            <Link to="/" className="inline-flex items-center gap-2 rounded-full bg-[color:var(--text-primary)] text-[color:var(--bg-primary)] px-6 py-3 text-sm">Volver al inicio</Link>
          </>
        )}
        {status === "pending" && (
          <>
            <div className="text-xs uppercase tracking-[0.28em] text-[color:var(--text-secondary)] mb-4">Pago pendiente</div>
            <h1 className="font-heading text-5xl md:text-6xl italic tracking-tighter mb-6">Casi allí.</h1>
            <p className="text-[color:var(--text-secondary)] mb-8">Tu banco todavía está procesando el pago. Te enviaremos un email cuando se confirme.</p>
            <Link to="/" className="inline-flex items-center gap-2 rounded-full bg-[color:var(--text-primary)] text-[color:var(--bg-primary)] px-6 py-3 text-sm">Volver al inicio</Link>
          </>
        )}
        {(status === "expired" || status === "error") && (
          <>
            <div className="text-xs uppercase tracking-[0.28em] text-[color:var(--text-secondary)] mb-4">Algo no salió bien</div>
            <h1 className="font-heading text-5xl md:text-6xl italic tracking-tighter mb-6">Vuelve a intentarlo</h1>
            <p className="text-[color:var(--text-secondary)] mb-8">No hemos podido confirmar el pago. Puedes reintentar la reserva o escribirnos.</p>
            <Link to="/#cita" className="inline-flex items-center gap-2 rounded-full bg-[color:var(--text-primary)] text-[color:var(--bg-primary)] px-6 py-3 text-sm">Reservar de nuevo</Link>
          </>
        )}
      </div>
    </div>
  );
}
